import { Injectable } from '@angular/core';
import { AllowedVal, AttributeStateService } from '@ntap/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeduplikacijaAttributeStateService extends AttributeStateService {
  private selectedAgentsSubject = new BehaviorSubject<object[]>([]);
  selectedItems$: Observable<object[]> =
    this.selectedAgentsSubject.asObservable();

  private selectedAgents: object[] = [];

  setSelectedAgents(items: object[]): void {
    this.selectedAgents = items;
    this.selectedAgentsSubject.next(items);
  }

  override getAllowedValues(
    attributeMetadata: any,
    objectData: any,
    viewName: string
  ): Observable<AllowedVal[]> {
    const selectedAgents: object[] = this.selectedAgents;

    const allowedValues: AllowedVal[] = selectedAgents.map((item: any) => ({
      value: item['en~agent~id'],
      label: item['en~agent~naziv']
    }));

    return super.getAllowedValues(attributeMetadata, objectData, viewName).pipe(
      map((avs) => {
        return allowedValues.concat(avs);
      })
    );
  }
}
